import { STATUS } from '@const/healthStatus.constants';
import { HealthStatusSeverity, HealthStatusSeverityDTO, Status, StatusHostCfgBase } from '@dto/healthStatus.dto';
import { WebsocketReloadData } from '@dto/websocketMessage.dto';
import { useState } from 'react';
import { Link } from 'react-router';
import { XmTableScope } from 'src/component/table/XmTable';
import { ColProps, XmTableEntry } from "src/component/table/tableTypes";
import { GLOB } from 'src/util/Glob';
import useGetApiData from "../../hook/useGetApiData";
import StateInfo from './StateInfo';

interface Props {
  type: Status,
  url: string;
  wsData: WebsocketReloadData;
}

const StateTable = ({ type, url, wsData }: Props) => {
  const [state, , loading] = useGetApiData<HealthStatusSeverity[], HealthStatusSeverityDTO>(url, `Failed to get hs for state ${type}.`, [wsData], [], true, false);
  const [tscope] = useState(() => new XmTableScope<StatusHostCfgBase>());
  const devices = state[0]?.devices.sort((a, b) => GLOB.naturalSort(a.label, b.label)) || [];
  const filters: string[] = devices.map(d => d.types).flat().filter((v, i, arr) => arr.indexOf(v) === i);
  const handleCloseDrawer = () => GLOB.setAppState({ isHsOpen: false });

  const columns: ColProps<XmTableEntry & StatusHostCfgBase>[] = [
    {
      title: "Name",
      key: "name",
      minWidth: "24em",
      sorter: (a, b) => a.label.localeCompare(b.label),
      render: ({ url, label }: StatusHostCfgBase) => <Link to={GLOB.menuService.getRouteLink(url, null, null, false, label)} onClick={handleCloseDrawer}>{label}</Link>
    },
    {
      title: "HW Type",
      dataIndex: "hw_type_label",
      key: "hw_type",
      minWidth: "19em",
      sorter: (a, b) => a.hw_type.localeCompare(b.hw_type)
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
      minWidth: "8em",
      sorter: (a, b) => a.class.localeCompare(b.class)
    },
    {
      title: "Type",
      key: "types",
      minWidth: "12em",
      filters: filters.map(filter => ({
        text: filter,
        value: filter
      })),
      onFilter: (value: string, record) => record.types.includes(value),
      render: ({ types }: StatusHostCfgBase) => types.join(', ')
    },
    {
      title: "Detail",
      key: "detail",
      minWidth: "4em",
      className: 'detail-cell',
      render: (record: StatusHostCfgBase) => <StateInfo title={`${record.label} (${record.hw_type_label})`} info={record.note} reason={type == 'ignored' ? record.ignore_reason : null} />
    }
  ];

  return <>
    <tscope.XmTable
      key={`${type}-table`}
      renderProps={{ noClipboard: true }}
      loading={loading}
      columns={columns}
      rowKey={(device: StatusHostCfgBase) => device.item_id}
      dataSource={devices}
      pagination={false}
      fillHeight
    />
    {type === STATUS.IGNORED && <p>Health Status of individual devices can be set to &quot;Ignored&quot;.<br />
      You can configure this property in the device configuration form.</p>}
  </>;
};

export default StateTable;
